import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { withTheme, Dialog, Grid } from '@material-ui/core';
import { compose } from "recompose";
import PickupOperationTimer from '../PickupEventHandler/PickupOperationsLogger/PickupOperationTimer';

const styles = theme => ({
    dialog: { 
        padding: '20px', 
        width: '400px', 
        backgroundColor: theme.ModalBGColor,
        display: 'flex',
        flexDirection: 'column'
    },
    eventName: { 
        fontWeight: 'bold',  
        color: theme.TextColor,
        marginLeft: 16  // Add left margin to align with timer
    },
    textColumn: { 
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    }
})

function LoaderDialog(props) {
    const { classes, eventName, ...otherProps} = props;
    const showPickupProcessingTimer = false;
    return (
        <Dialog onClose={props.onCancel} classes={{ paper: classes.dialog }} open={true} {...(otherProps || {})}>
            <Grid container>
                <Grid item xs={3}><CircularProgress /></Grid>
                <Grid item xs={7} className={classes.textColumn}>
                    <span className={classes.eventName}>{eventName} is in progress</span>
                    {showPickupProcessingTimer && <PickupOperationTimer />}
                </Grid>
            </Grid>
        </Dialog>
    )
}
export default compose(
    withTheme(),
    withStyles(styles)
)(LoaderDialog);
